import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinbanglore() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Bangalore',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Bangalore',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Bangalore, catering to the transportation needs of IT parks, corporate offices, business centers, and industrial hubs across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Bangalore.',

    top: 'Top Places to Visit in Bangalore with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is an architectural marvel inspired by England’s Windsor Castle, built in the 19th century. The palace features Tudor-style architecture, fortified towers, elegant woodwork, and sprawling gardens. Visitors can explore the royal interiors, vintage furniture, and photo galleries. The palace also hosts cultural events, music concerts, and exhibitions, offering a blend of history, art, and heritage in the heart of Bangalore."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green oasis in Bangalore, famous for its diverse collection of flora, centuries-old trees, glasshouse, and flower shows. The garden offers walking paths, serene lakes, and picturesque landscapes, making it ideal for nature lovers, photographers, and families. Seasonal flower exhibitions attract visitors from across the city and beyond."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush, sprawling park in central Bangalore, covering over 300 acres. With walking trails, jogging paths, playgrounds, and abundant greenery, it serves as a popular recreational spot for locals and tourists alike. The park also houses several government buildings and statues, creating a perfect blend of nature, culture, and history in the city."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building and a symbol of Bangalore’s political and architectural heritage. Built in a Neo-Dravidian style, it features grand pillars, domes, and intricately carved stonework. Visitors admire the building’s majestic facade, especially during evening lightings. Though entry is restricted, the surrounding area and viewpoints provide excellent photo opportunities."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "The ISKCON Temple is a major spiritual and cultural center in Bangalore, dedicated to Lord Krishna. The temple complex features traditional architecture, colorful murals, a large prayer hall, and beautiful gardens. Visitors can attend devotional ceremonies, participate in cultural programs, and enjoy vegetarian meals at the temple’s food court. It is a serene escape for meditation and spiritual learning in the bustling city."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s bustling shopping hub, offering a variety of clothing, footwear, jewelry, accessories, and street food. It is popular among locals and tourists looking for shopping, bargain hunting, and exploring vibrant street markets. The lively atmosphere, diverse shops, and colorful storefronts make it a must-visit for retail enthusiasts."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a major wildlife destination near Bangalore, featuring a zoo, butterfly park, safari rides, and trekking trails. Visitors can observe lions, tigers, elephants, and a variety of other animals in naturalistic settings. The park is perfect for families, wildlife enthusiasts, and students seeking educational and recreational experiences close to the city."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a picturesque water body located in central Bangalore, ideal for boating, photography, and evening strolls. The lake is surrounded by lush greenery, walking paths, and small islands. It is a peaceful spot for relaxation, picnics, and spending time with family or friends, offering a serene escape within the urban landscape."
  },
  {
    "title": "Nandi Hills",
    "description": "Located on the outskirts of Bangalore, Nandi Hills is a scenic hill station known for its sunrise views, trekking trails, and historical sites like Tipu Sultan’s Summer Palace. The hill offers a refreshing escape from the city heat, with cool breezes, lush landscapes, and panoramic vistas. It is a favorite destination for nature lovers, photographers, and adventure seekers."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla is one of India’s top amusement parks, located near Bangalore, offering thrilling rides, water slides, and family entertainment zones. The park is ideal for a fun-filled day with family and friends, featuring safe rides, adventure zones, and well-maintained facilities. Seasonal events and themed attractions make it a popular destination for locals and tourists seeking excitement and leisure."
  }
],


"services": [
{
"name": "Bangalore Employee Transport",
"description": "Bangalore Employee Transport delivers highly organized, technology-driven commuting solutions for employees working in IT parks, tech campuses, corporate offices, and industrial zones across the city. The service offers GPS-enabled fleets, automated routing algorithms, real-time tracking, shift-based operations, and professionally trained drivers. Designed for large-scale corporate mobility, it ensures punctual, safe, and seamless daily transport for workforce teams across all major business districts in Bangalore."
},
{
"name": "Bangalore IT Park Cabs",
"description": "Bangalore IT Park Cabs provides dedicated transportation solutions for employees working in Electronic City, Whitefield, Manyata Tech Park, Bagmane Tech Park, Embassy Tech Village, and other major IT hubs. With comfortable sedans and SUVs, strict safety standards, automated scheduling, and high-precision route optimization, it ensures hassle-free daily commuting for IT professionals while supporting multi-shift operations and high-volume employee movement."
},
{
"name": "Corporate Shuttle Bangalore",
"description": "Corporate Shuttle Bangalore offers large-capacity shuttle vans, minibuses, and MUVs designed for bulk staff transportation. Featuring GPS monitoring, trained drivers, structured route planning, and real-time fleet coordination, the service supports corporates handling high employee volumes, multi-location campuses, and shift-based mobility needs. Ideal for tech companies, BPOs, and large enterprises seeking reliable group commuting solutions."
},
{
"name": "Staff Pickup Drop Bangalore",
"description": "Staff Pickup Drop Bangalore delivers punctual, efficient, and safe pickup–drop commute services for employees across the city. The service includes route mapping, driver allocation, trip tracking, and automated schedules to match office timings. Designed for tech firms, industrial units, startups, and large corporates, it ensures stress-free, reliable transport for staff on a daily basis."
},
{
"name": "Business Taxi Bangalore",
"description": "Business Taxi Bangalore offers premium on-demand and scheduled cab services tailored for corporate travel, business meetings, client visits, and executive mobility. Featuring professional chauffeurs, clean sedans, executive SUVs, and seamless dispatch coordination, the service supports efficient and comfortable business travel across Bangalore’s commercial districts."
},
{
"name": "Office Commute Bangalore",
"description": "Office Commute Bangalore specializes in daily employee mobility for companies of all sizes. The service features optimized transit routes, GPS-enabled cabs, well-trained drivers, and multi-shift operations, ensuring staff members reach their offices safely, comfortably, and on time. Ideal for IT companies, corporates, industrial units, and service-based organizations."
},
{
"name": "Monthly Cab Service Bangalore",
"description": "Monthly Cab Service Bangalore offers fixed-plan, long-term transportation solutions for companies requiring dedicated cabs for daily employee commute. With predictable pricing, standby vehicles, trained chauffeurs, and real-time monitoring, it ensures uninterrupted mobility for startups, enterprise-level companies, and industrial organizations throughout the month."
},
{
"name": "Corporate Fleet Bangalore",
"description": "Corporate Fleet Bangalore provides end-to-end fleet management solutions including sedans, SUVs, employee shuttles, and multi-seater vans. The service includes driver management, GPS tracking, route optimization, on-road supervision, and maintenance handling to ensure smooth, safe, and scalable employee commute operations across Bangalore."
},
{
"name": "Outstation Corporate Cab Bangalore",
"description": "Outstation Corporate Cab Bangalore offers safe, comfortable, and professionally managed intercity travel for business trips, corporate tours, factory visits, and client meetings. With trained long-route drivers, GPS supervision, and well-maintained sedans/SUVs, it ensures smooth and reliable corporate travel to major destinations around Karnataka and neighboring states."
},
{
"name": "Sedan Cab Bangalore",
"description": "Sedan Cab Bangalore provides premium sedan vehicles ideal for executives, managers, and employees seeking comfortable daily commuting or business travel. With spacious interiors, professional chauffeurs, GPS tracking, and on-time service standards, it ensures a high-quality travel experience across Bangalore."
},
{
"name": "SUV Cab Bangalore",
"description": "SUV Cab Bangalore offers spacious and powerful SUVs suitable for team travel, field operations, long-distance trips, and executive mobility. The service ensures safety, comfort, route efficiency, and professional driving standards, making it ideal for corporate teams and senior management."
},
{
"name": "Company Cab Provider Bangalore",
"description": "Company Cab Provider Bangalore delivers fully managed corporate cab services for organizations requiring consistent, scalable, and reliable employee transport. Supported by GPS-enabled fleets, experienced drivers, automated rostering, and robust safety protocols, it ensures smooth daily operations for enterprises across the city."
},
{
"name": "Employee Mobility Bangalore",
"description": "Employee Mobility Bangalore offers comprehensive workforce transportation solutions including office commute, last-mile transit, multi-shift support, and route optimization. The service leverages advanced mobility platforms, real-time monitoring, and expert operational management to ensure efficient and dependable employee travel across Bangalore’s major tech and industrial zones."
},
{
"name": "Best Corporate Cabs Bangalore",
"description": "Best Corporate Cabs Bangalore delivers top-tier transportation services featuring luxury sedans, premium SUVs, professional chauffeurs, high safety standards, and guaranteed punctuality. Designed for executives, corporate staff, and business travelers, this premium service ensures superior comfort, reliability, and operational excellence."
},
{
"name": "Affordable Office Cabs Bangalore",
"description": "Affordable Office Cabs Bangalore offers budget-friendly employee transportation without compromising on safety or service quality. Featuring clean vehicles, experienced drivers, optimized routing, and real-time trip tracking, it provides cost-effective yet dependable mobility solutions for corporates, SMEs, and fast-growing startups."
}
],

"tableData": [
["Bangalore Employee Transport", "Bangalore IT Park Cabs"],
["Corporate Shuttle Bangalore", "Staff Pickup Drop Bangalore"],
["Business Taxi Bangalore", "Office Commute Bangalore"],
["Monthly Cab Service Bangalore", "Corporate Fleet Bangalore"],
["Outstation Corporate Cab Bangalore", "Sedan Cab Bangalore"],
["SUV Cab Bangalore", "Company Cab Provider Bangalore"],
["Employee Mobility Bangalore", "Best Corporate Cabs Bangalore"],
["Affordable Office Cabs Bangalore", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Bangalore",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides efficient and reliable corporate cab services in Bangalore, ensuring smooth transportation for employees and business executives across the city."
  },
  {
    "WhyChooseheading": "On-Time Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs across Bangalore’s tech parks, business hubs, and industrial zones, ensuring employees reach work on time."
  },
  {
    "WhyChooseheading": "Professional & Skilled Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs deliver safe, courteous, and comfortable rides while following corporate travel standards and city traffic guidelines."
  },
  {
    "WhyChooseheading": "Well-Maintained & Diverse Vehicle Fleet",
    "WhyChoosedescription": "Choose from a wide range of sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for seamless corporate commuting."
  },
  {
    "WhyChooseheading": "Tailored Corporate Travel Packages",
    "WhyChoosedescription": "We offer customized cab rental plans designed to meet the unique travel needs of companies and employees in Bangalore’s busy corporate environment."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to handle bookings, emergency travel requirements, and route adjustments for uninterrupted employee transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are disinfected regularly and equipped with advanced safety features, ensuring secure and hygienic rides for corporate staff and executives."
  },
  {
    "WhyChooseheading": "Smooth Booking & Coordination",
    "WhyChoosedescription": "Our seamless booking process and efficient coordination make corporate commuting hassle-free for HR teams and travel managers."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Bangalore?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and employees across Bangalore.',
  },
  {
    question: 'What types of corporate cab services are available in Bangalore?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet management solutions.',
  },
  {
    question: 'Do you support daily commuting for employees in Bangalore?',
    answer: 'Yes, we offer efficient daily commute solutions with timely pickups, smart route planning, and flexible shift-based transportation.',
  },
  {
    question: 'How can companies book corporate cab services in Bangalore?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicle options do you offer for corporate travel?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate needs.',
  },
  {
    question: 'Do you provide long-term corporate transportation contracts in Bangalore?',
    answer: 'Yes, we offer monthly, quarterly, and annual corporate transportation contracts with flexible pricing models.',
  },
  {
    question: 'Are the cabs equipped with safety features?',
    answer: 'Yes, all vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs.',
  },
  {
    question: 'Do you support multi-shift employee cab services in Bangalore?',
    answer: 'Absolutely. We manage employee transportation for early morning, night, weekend, and rotational shifts.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Rao',
    feedback: 'Highly reliable corporate cab service in Bangalore. Timely, safe, and very professional. Ideal for our daily employee transport.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavya Shetty',
    feedback: 'Excellent corporate transportation service. Smooth coordination, clean vehicles, and polite drivers. Great experience!',
    rating: 5,
  },
];

































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Bangalore",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-bangalore.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services in Bangalore, including employee transport, IT park cabs, corporate shuttles, staff pickup & drop, business taxis, office commute solutions, monthly cab services, outstation trips, and corporate fleet solutions for companies operating in Bangalore.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-bangalore"
  }
};



  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Bangalore | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Bangalore including employee transport, IT park cabs, corporate shuttle services, staff pickup & drop, business taxis, monthly cab service, outstation trips, and corporate fleet solutions for companies."
  />

  <meta
    name="keywords"
    content="Bangalore Employee Transport, Bangalore IT Park Cabs, Corporate Shuttle Bangalore, Staff Pickup Drop Bangalore, Business Taxi Bangalore, Office Commute Bangalore, Monthly Cab Service Bangalore, Corporate Fleet Bangalore, Outstation Corporate Cab Bangalore, Sedan Cab Bangalore, SUV Cab Bangalore, Company Cab Provider Bangalore, Employee Mobility Bangalore, Best Corporate Cabs Bangalore, Affordable Office Cabs Bangalore"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinbanglore;